import { useQueryClient } from "@tanstack/react-query";

import {
    getGetEntitiesEntityIdQueryKey,
    getGetEntitiesQueryKey,
    usePatchEntities,
} from "api/generated/entities/entities";
import { getGetUsersUserIdEntitiesQueryKey } from "api/generated/users/users";
import { invalidateAssignmentCountQuery } from "org/user/queries/useAssignmentCountQuery";

export function useUpdateEntitiesAccessRightsMutation() {
    const queryClient = useQueryClient();
    return usePatchEntities({
        mutation: {
            onSuccess: async (_response, { data }) => {
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey: getGetEntitiesQueryKey(),
                    }),
                    ...data.entityIds.map((entityId) =>
                        queryClient.invalidateQueries({
                            queryKey: getGetEntitiesEntityIdQueryKey(entityId),
                        })
                    ),
                    ...data.userIds.flatMap((userId) => [
                        queryClient.invalidateQueries({
                            queryKey: getGetUsersUserIdEntitiesQueryKey(userId),
                        }),
                        invalidateAssignmentCountQuery(userId.toString()),
                    ]),
                ]);
            },
        },
    });
}
